import type { Ref } from 'vue'

export function handleValidationErrors(
    fieldErrors: {
        path: string
        message: string
    }[],
    invalidInitials: Ref<Set<number>>,
    invalidSignatures: Ref<Set<number>>
) {
    invalidInitials.value.clear()
    fieldErrors.forEach(error => {
        if (error.path === 'initials') {
            invalidInitials.value.add(Number(error.message))
        }
    })

    invalidSignatures.value.clear()
    fieldErrors.forEach(error => {
        if (error.path === 'signatures') {
            invalidSignatures.value.add(Number(error.message))
        }
    })
}
